import script from "./NeedGeneratePeriodReportModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NeedGeneratePeriodReportModal.vue?vue&type=script&setup=true&lang=js"

import "./NeedGeneratePeriodReportModal.vue?vue&type=style&index=0&id=00a6773f&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00a6773f"]])

export default __exports__